import { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const initialState = { messages: [] };


function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return { messages: action.payload };
    case 'add':
      return { messages: [...state.messages, action.payload] };
    case 'clear':
      return { messages: [] };
    case 'hide':
      return { messages: [...state.messages] };
    case 'view':
        return { messages: [...state.messages] };
    default:
      throw new Error('Action not found');
  }
}

function useMessages() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const idToken = useSelector((state) => state.tokens.idToken);

  const clearMessages = () => {
    console.log("clearMessages()");
    dispatch({ type: 'clear' });
  };
  
  const getMessages = async (filters = {}) => {
    try {
      let allItems = [];
      let pagination = {};
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        allItems = [
          {
              "messageId": "2a576471-862a-45ca-8727-b3499ca7ff0b",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.1001",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:25.599750",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.1001"
          },
          {
              "messageId": "bdc320cd-4c53-4163-bade-662c064fa2d0",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.0110",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:25.271107",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.0110"
          },
          {
              "messageId": "b6fc55c1-fd44-4a72-a3f4-071b24ab369a",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.0110",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:25.018142",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.0110"
          },
          {
              "messageId": "022d2c76-98d8-4ae9-9ea2-43bb898c4e1c",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.0110",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:24.665403",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.0110"
          },
          {
              "messageId": "541d2aa8-e04b-4f48-9692-5cc098a66773",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.0110",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:24.332446",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.0110"
          },
          {
              "messageId": "4e59e504-0255-4215-b5fa-f5a2c54c6947",
              "patientFirstName": "JELINE",
              "patientLastName": "TEST",
              "patientDob": "1975-10-23",
              "patientGender": "F",
              "providerFirstName": "",
              "providerLastName": "",
              "messageType": "trans-mdm",
              "facilityId": "1.2.3.4.5.9.99.999.9999.1224.1",
              "orderingProvider": null,
              "messageTimestamp": "2025-03-19T12:28:23.798621",
              "sourceOrgName": "1.2.3.4.5.9.99.999.9999.0110"
          },
        ]
      } else {
        let messages_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/message';
        
        const showHidden = filters.showHiddenMessages ? "true" : "false";
        const hideCareTeam = filters.hideCareTeam ? "true" : "false";
        const hideNonCareTeam = filters.hideNonCareTeam ? "true" : "false";
        let options = { 
          headers: { 'Authorization': 'Bearer ' + idToken },
          params: {
            'show_hidden': showHidden,
            'hide_care_team': hideCareTeam,
            'hide_non_care_team': hideNonCareTeam,
            'limit': 10,
            'page': 1
          }
        };
        if('page' in filters){
          options.params.page = filters.page+1;
        }
        if('limit' in filters){
          options.params.limit = filters.limit;
        }
        if('sort_by' in filters && 'sort_order' in filters) {
          options.params.sort_by = filters.sort_by;
          options.params.sort_order = filters.sort_order;
        }

        const excludeKeys = new Set([
          "dateRange",
          "provider",
          "providerFirstName",
          "providerLastName",
          "showHiddenMessages",
          "hideCareTeam",
          "hideNonCareTeam",
          "page",
          "limit",
        ]);
        let payload = {
          filters: Object.entries(filters)
            .filter(([key, value]) => !excludeKeys.has(key) && !(typeof value === "string" && value.trim() === ""))
            .map(([key, value]) => ({
              columns: [key],
              values: Array.isArray(value) ? value : [value]
          }))
        };

        if("dateRange" in filters) {
          if(filters.dateRange !== null && filters.dateRange.length > 0) {
            payload.filters.push({
              columns: ["messageTimestamp"],
              values: filters.dateRange
            });
          } 
        }

        if("provider" in filters && filters.provider.length > 0) {
          const npi_filter_fields = ["care_team_npis"];
          payload.filters.push({
            columns: npi_filter_fields,
            values: filters.provider
          });
        }

        let providerNameVals = [];
        if ("providerFirstName" in filters && filters.providerFirstName.trim() !== "") {
          providerNameVals.push(filters.providerFirstName);
        }
        if ("providerLastName" in filters && filters.providerLastName.trim() !== "") {
          providerNameVals.push(filters.providerLastName);
        }
        if(providerNameVals.length > 0 ) {
          payload.filters.push({
            columns: ["ordering_provider_name"],
            values: providerNameVals
          });
        }
        
        await axios.post(messages_url, payload, options)
        .then((res) => {
          allItems = res.data.data;
          pagination = res.data.pagination;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            window.alert("Token invalid - please refresh or log in");
          }
          console.error(err);
        });
      }

      dispatch({ type: 'set', payload: allItems });
      return {
        data: allItems,
        pagination: pagination
      };
    } catch (e) {
      console.error(e);
    }
  };

  const hideMessages = async (msgData) => {
    console.log("hideMessages()");

    try {
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        console.log("Successfully hid messages");
      } else {
        const hide_messages_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/user/preferences';
        const headers = {headers: { 'Authorization': 'Bearer ' + idToken }};
        await axios.put(hide_messages_url, msgData, headers)
        .then((res) => {
          console.log("Successfully hid messages");
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            window.alert("Token invalid - please refresh or log in");
          }
          console.error(err);
        });
      }

      dispatch({ type: 'hide' });
    } catch (e) {
      console.error(e);
    }

    
  };

  const viewMessage = async (messageId) => {
    console.log("viewMessage() ");

    try {
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        console.log("Successfully retrieved message");
      } else {
        const view_message_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/message/'+messageId;
        const options = {
          headers: { 'Authorization': 'Bearer ' + idToken },
          responseType: "arraybuffer"
        };
        await axios.get(view_message_url, options)
        .then((res) => {
          console.log("Successfully retrieved message");
          const base64String = new TextDecoder().decode(new Uint8Array(res.data));
          const binaryData = atob(base64String); 
          const byteArray = new Uint8Array(binaryData.length);

          for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          // Open PDF in a new tab
          window.open(blobUrl, "_blank");
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            window.alert("Token invalid - please refresh or log in");
          }
          console.error(err);
        });
      }

      dispatch({ type: 'view' });
    } catch (e) {
      console.error(e);
    }

    
  };

  const downloadMessages = async (messageIds) => {
    console.log("downloadMessages() ");

    try {
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        console.log("Successfully retrieved messages");
      } else {
        const base_message_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/message/'
        const options = {
          headers: { 'Authorization': 'Bearer ' + idToken },
          responseType: "arraybuffer"
        };
        
        const pdfRequests = messageIds.map((msgId) =>
          axios.get(base_message_url+msgId, options
          ).then(response => ({ data: response.data, filename: 'Report_'+msgId+'.pdf' }))
        );
        
        const pdfResponses = await Promise.all(pdfRequests);
        
        pdfResponses.forEach(({ data, filename }) => {
          const base64String = new TextDecoder().decode(new Uint8Array(data));
          const binaryData = atob(base64String); 
          const byteArray = new Uint8Array(binaryData.length);

          for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });

        dispatch({ type: 'view' });
      }
    } catch (e) {
      console.error(e);
    }

    
  };

  return [state.messages, getMessages, clearMessages, hideMessages, viewMessage, downloadMessages];
}

export default useMessages;
